import React from 'react'
import { Box, Typography } from '@mui/material'

// Local Import
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxCheckbox from 'components/custom/AdxCheckbox'

const CalendarApiFilter = ({ title, searchString, apiData, data, setData }) => {
  // title. string.
  // data. object of { id: number, name: string }

  const Typo = ({ text, ...rest }) => <Typography {...rest}>{text}</Typography>

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          my: 0.75,
        }}
      >
        <Typo text={title} color="light-gray-text.main" />
        {data.length < apiData?.length ? (
          <Typography
            variant="subtitle1"
            color="alternate.main"
            sx={{ userSelect: 'none' }}
            onClick={() =>
              setData(
                title,
                searchString,
                apiData?.map((d) => d.id)
              )
            }
          >
            Select All
          </Typography>
        ) : (
          <Typography
            variant="subtitle1"
            color="alternate.main"
            sx={{ userSelect: 'none' }}
            onClick={() => setData(title, searchString, [])}
          >
            Deselect All
          </Typography>
        )}
      </Box>
      {apiData?.map((d) => (
        <Box key={d.id} display="flex" flexDirection="column">
          <AdxFormControlLabel
            label={d.name}
            control={
              <AdxCheckbox
                name={d.name}
                checked={Boolean(data.find((id) => d.id === id))}
                onChange={(event) => {
                  if (event.target.checked) {
                    // setData((prevState) => [...prevState, data.id]);
                    setData(title, searchString, [...data, d.id])
                  } else {
                    // setData((prevState) =>
                    //   prevState.filter((id) => id !== data.id)
                    // );
                    setData(
                      title,
                      searchString,
                      data.filter((id) => id !== d.id)
                    )
                  }
                }}
              />
            }
          />
        </Box>
      ))}
    </>
  )
}

export default CalendarApiFilter
